// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/errorPageStyles.js";

// core components
import GridContainer from "components/UI/Grid/GridContainer";
import GridItemTS from "components/UI/Grid/GridItemTS";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(styles as any);

export default function ErrorPage() {
  const classes = useStyles();
  const { t } = useTranslation("error");

  return (
    <div className={classes.contentCenter}>
      <GridContainer>
        <GridItemTS md={12}>
          <h1 className={classes.title}>404</h1>
          <h2 className={classes.subTitle}>{t("page-not-found-title")}</h2>
          <h4 className={classes.description}>{t("page-not-found-message")}</h4>
        </GridItemTS>
      </GridContainer>
    </div>
  );
}
